import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsBluetoothIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_bluetooth"}/>
}
